import {
   FETCH_PO_LINE_AUDIT_DETAILS_NEW,
   FETCH_PO_LINE_AUDIT_DETAILS_NEW_LOADING
  } from "../../actions/types";
  
  const intialState = { backdropText: "Please wait...",
    poLineAuditsNewData: { data: { poLineAuditTrail: [] } },
    poLineAuditsNewDataLoading: false,
   };
  
  export default function (state = intialState, action) {
    switch (action.type) {
      case FETCH_PO_LINE_AUDIT_DETAILS_NEW:
        return {
          ...state,
          poLineAuditsNew: action.payload,
        };
        case FETCH_PO_LINE_AUDIT_DETAILS_NEW_LOADING:
            return {
              ...state,
              poLineAuditsNewLoading: action.payload,
            };
      default:
        return state;
    }
  }
  